/**
 * AWS Amplify Configuration
 * *
 * GraphQL requests are signed via src/utils/signedFetch.js (aws4fetch + Cognito Identity Pool).
 */

const amplifyConfig = {
  Auth: {
    Cognito: {
      identityPoolId: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID || '',
      allowGuestAccess: true,
      region: import.meta.env.VITE_AWS_REGION || 'ap-southeast-2'
    },
  },
};

export default amplifyConfig;
